import { createSelector } from 'reselect'
import { selectHasRecentLoan } from 'src/store/selectors/home'
import { selectRefiDetails } from 'src/store/selectors/refinance'
import {
  selectRefiEligible,
  selectCurrentCELs
} from 'src/store/selectors/home/loans'
import {
  selectLeverageableEquityForLTV,
  selectEmergencyReservePool,
  selectQualifiedEquityListings,
  CASHOUT_LTV,
  CASHOUT_MINIMUM,
  EMERGENCY_RESERVE_MINIMUM
} from 'src/store/selectors/home/equity'
import {
  selectCompanyHasDisabledWINMortgagePaymentOptions,
  selectDisplayYlopoSpecificContent,
  selectHasSmsOutreachFeature
} from 'src/store/selectors/customerProfile'
import {
  selectHomeownerMarketLoading,
  selectHomeownerMarketDetailRequested,
  selectCurrentMarketHasDataForRender
} from 'src/store/selectors/marketRecord'
import { selectLTVPercent } from 'store/selectors/home/pmi'
import { equitySearchTable } from 'src/constants/equity'

// Duplicating logic in RefiByYearsInHomeContainer
export const selectShouldRenderRefiOptions = createSelector(
  selectHasRecentLoan,
  selectRefiDetails,
  (hasRecentLoan, refiDetails) =>
    !hasRecentLoan && refiDetails && refiDetails.length > 0
)

// Duplicating logic in withEquityAndPurchasingPowerProps and CashoutContainer
export const selectShouldRenderCashout = createSelector(
  selectRefiEligible,
  selectLeverageableEquityForLTV(CASHOUT_LTV),
  (eligible, excess) => eligible && excess >= CASHOUT_MINIMUM
)

export const selectShouldRenderEmergencyReserve = createSelector(
  selectShouldRenderCashout,
  selectEmergencyReservePool,
  (showCashout, pool) => showCashout && pool >= EMERGENCY_RESERVE_MINIMUM
)

export const selectShouldRenderMortgageRelief = createSelector(
  selectCompanyHasDisabledWINMortgagePaymentOptions,
  selectCurrentCELs,
  (featureCheck, currentCELs) =>
    !featureCheck && currentCELs && currentCELs.length > 0
)

export const selectShouldRenderMarketPanel = createSelector(
  selectHomeownerMarketLoading,
  selectHomeownerMarketDetailRequested,
  selectCurrentMarketHasDataForRender,
  (loading, loaded, hasEnoughData) => loading || (loaded && hasEnoughData) // TODO: build FF?
)

export const selectShouldRenderEquitySmartSearchFeatures = createSelector(
  selectLTVPercent,
  ltvPercent => {
    return (
      ltvPercent <= equitySearchTable.LTV_MAX_PERCENT_FOR_ESS &&
      ltvPercent >= equitySearchTable.LTV_MIN_PERCENT_FOR_ESS
    )
  }
)

export const selectShouldRenderEquitySmartSearchYlopoListings = createSelector(
  selectDisplayYlopoSpecificContent,
  selectQualifiedEquityListings,
  (showYlopo, qualifiedListings) => {
    return showYlopo && qualifiedListings && qualifiedListings.length >= 3
  }
)

export const selectShouldRenderSmsOptInFlow = createSelector(
  selectHasSmsOutreachFeature,
  hasFeature => Boolean(hasFeature)
)
